module.exports = __webpack_public_path__ + "img/logo-sungevity-engie-white.6133f857.svg";